// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_integrations_ui_styles" + "." + "610c0697" + ".chunk.css";
};